




























































































































import { Evenement } from '@/domain/Evenement'
import mixins from 'vue-typed-mixins'
import Vue from 'vue'
import evenementMixin from './evenementMixin'
import Openable from '@/global/viewmodels/openable'
//@ts-ignore
import CKEditor from '@ckeditor/ckeditor5-vue2'
//@ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default mixins(evenementMixin).extend({
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: ['bold', 'italic', 'link', 'undo', 'redo', 'numberedList', 'bulletedList'],
                    shouldNotGroupWhenFull: true,
                },
            },
            menu: '',
            selectedEvent: null as null | Evenement,
        }
    },
    components: {
        ckeditor: CKEditor.component,
    },
    methods: {
        seeLess() {
            this.selectedEvent = null
        },
        seeMore(event: Evenement) {
            this.selectedEvent = event

            Vue.nextTick(() => {
                const id = 'event-' + event.id
                const yOffset = -70
                const element = document.getElementById(id)
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

                    window.scrollTo({ top: y, behavior: 'smooth' })
                }
            })
        },
        modifierImage(event: Evenement) {
            this.evenement = event
            this.dialogImage.open()
        },
        editEvenement: function (event: Evenement) {
            this.evenement = event
            this.dialog.open()
        },
        formatDate(date: string | undefined) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    },
    computed: {
        evenementDateFormatted: function (): string | null {
            return this.formatDate(this.evenement?.date)
        },
    },
})
